import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34cee244"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "summary__promo-list"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "summary__promo-list--header" }, "Applied promos:", -1 /* HOISTED */))
const _hoisted_3 = { class: "promo__title" }
const _hoisted_4 = { class: "promo__value" }
const _hoisted_5 = { class: "promo__delete" }

import { usePromo } from '@/store';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromoList',
  setup(__props) {

const { appliedPromos, isDiscounted } = storeToRefs(usePromo());
const { removePromo } = usePromo();

return (_ctx: any,_cache: any) => {
  const _component_AppNumber = _resolveComponent("AppNumber")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_unref(isDiscounted))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appliedPromos), (promoCode) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "summary__promo-list--code",
            key: promoCode.id
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(promoCode.title), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(" Discount: "),
              _createVNode(_component_AppNumber, {
                input: promoCode.value * 100,
                fixed: 0
              }, null, 8 /* PROPS */, ["input"]),
              _createTextVNode("% ")
            ]),
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-xmark",
                onClick: ($event: any) => (_unref(removePromo)(promoCode.id))
              }, null, 8 /* PROPS */, ["onClick"])
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}
}

})